import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { 
	displayModalCreate,
	updateInputsInModalCreate,
	createOrUpdateGrupos
} from '../../actions/grupos'

class ModalCreate extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalCreate')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreate .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreate(false, '', ''), 300)
	}

	render() {
		const { modalCreate } = this.props
		if (!modalCreate.get('show')) {
			return null
		}

		return(
			<Modal id="modalCreate" show={ true } ZIndex={ 2000 }>
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdateGrupos(modalCreate.get('data'), modalCreate.get('mode')) }} noValidate>
					<ModalHeader title={ modalCreate.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="floppy-o" disabled={ modalCreate.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody >
						<div style={{ width: '600px' }}>
							<div className="row" style={{ height: '100%' }}>
								<div className="col-md-12">
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label className="control-label">Nombre</label>
												<input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'nombre']) } onChange={ (e) => this.props.updateInputsInModalCreate('nombre', e.target.value) } disabled={ modalCreate.get('mode') === 'edit' } />
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label className="control-label">Descripción</label>
												<textarea rows={3} className="form-control input-sm" value={ modalCreate.getIn(['data', 'descripcion']) } onChange={ (e) => this.props.updateInputsInModalCreate('descripcion', e.target.value) } />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreate: state.grupos.get('modalCreate'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreate: (show, title, mode) => dispatch(displayModalCreate(show, title, mode)),
		updateInputsInModalCreate: (attr, value) => dispatch(updateInputsInModalCreate(attr, value)),
		createOrUpdateGrupos: (data, mode) => dispatch(createOrUpdateGrupos(data, mode)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Grupos/ModalCreate.jsx